'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/20/solid'
import React from 'react'

type ListBoxProps = {
  label?: string | React.ReactNode
  id?: string
  name?: string
  inline?: boolean
  compact?: boolean
  option: { id: number, name: string | any }[] | any[]
  value?: any
  onChange: (val: number) => void
  optional?: boolean
  disabled?: boolean
} & (React.ComponentPropsWithoutRef<'select'>)

export function ListBox(props: ListBoxProps) {
  const { label, id, name, inline, compact, option, value, onChange, className, optional, disabled } = props
  const errMsg = _.get(props, 'data-error')
  function handleChange(val: any) {
    if (val?.toString() === value?.toString()) return
    onChange(val)
  }
  return (
    <Listbox value={value?.toString()} onChange={(val) => handleChange(val)} disabled={disabled || false}>
      <div className={twMerge(className, inline ? '' : 'w-full')}>
        {
          label &&
          <label htmlFor={id || name} className='form-label'>
            {label}
            {
              optional &&
              <span className='font-light ml-1.5 text-zinc-600 dark:text-zinc-400'>(optional)</span>
            }
          </label>
        }
        <div className={twMerge('relative w-full', inline ? 'mt-0' : 'mt-1')}>
          <ListboxButton className={
            twMerge(
              'form-listbox',
              compact && 'md:h-9!', (compact || inline) && 'md:text-sm!'
            )
          }>
            <span className='block truncate pl-1 pr-8'>
              {_.find(option, x => { return x?.id?.toString() === value?.toString() })?.name}
            </span>
            <span className='form-input-icon'>
              <ChevronUpDownIcon aria-hidden='true' className='size-5 text-stone-400' />
            </span>
          </ListboxButton>
          <ListboxOptions transition className='form-options'>
            {
              _.map(option, (o, idx) =>
                <ListboxOption key={idx} value={o?.id?.toString()} className='form-option'>
                  {o.name}
                </ListboxOption>
              )
            }
          </ListboxOptions>
        </div>
        {
          errMsg && <div className='form-error-message'>{errMsg}</div>
        }
      </div>
    </Listbox >
  )
}